// extracted by mini-css-extract-plugin
export var cancelButton = "_pc-5";
export var content = "_pc-3";
export var createButton = "_pc-6";
export var drawerContainer = "_pc-0";
export var footer = "_pc-2";
export var header = "_pc-1";
export var orderFormColumn = "_pc-4";